import { render, staticRenderFns } from "./bankForm.vue?vue&type=template&id=3dbef578&scoped=true"
import script from "./bankForm.vue?vue&type=script&lang=js"
export * from "./bankForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbef578",
  null
  
)

export default component.exports